// In-memory-only store for decrypted vault key material (VMK, private key).
// Deliberately not persisted to sessionStorage/localStorage: an XSS foothold
// that can read Web Storage should not also get the keys needed to decrypt
// vault data. Values are lost on page reload or tab close by design -
// ProtectedRoute already redirects to /login when hasUnlockedVault() is
// false, so a reload correctly forces the user to re-derive the keys from
// their password rather than silently continuing with stale key material.

let vmk: string | null = null;
let privateKey: string | null = null;

export function setVmk(value: string): void {
  vmk = value;
}

export function getVmk(): string | null {
  return vmk;
}

export function setPrivateKey(value: string): void {
  privateKey = value;
}

export function getPrivateKey(): string | null {
  return privateKey;
}

export function clearVaultKeys(): void {
  vmk = null;
  privateKey = null;
}
